module.exports = __webpack_public_path__ + "img/titlebg.4e4ee862.png";